import { create } from 'zustand';

const SIDEBAR_KEY = 'nvr.ui.sidebar.collapsed';

function readPersistedCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(SIDEBAR_KEY) === '1';
  } catch {
    return false;
  }
}

function persistCollapsed(collapsed: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(SIDEBAR_KEY, collapsed ? '1' : '0');
  } catch {
    // Storage may be unavailable (private mode, quota). Non-fatal.
  }
}

interface UiState {
  sidebarCollapsed: boolean;
  isFullscreen: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleSidebar: () => void;
  setFullscreen: (active: boolean) => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  sidebarCollapsed: readPersistedCollapsed(),
  isFullscreen: false,
  setSidebarCollapsed: (collapsed) => {
    if (get().sidebarCollapsed === collapsed) return;
    persistCollapsed(collapsed);
    set({ sidebarCollapsed: collapsed });
  },
  toggleSidebar: () => {
    const next = !get().sidebarCollapsed;
    persistCollapsed(next);
    set({ sidebarCollapsed: next });
  },
  setFullscreen: (active) => set({ isFullscreen: active }),
}));
